import React from 'react';

const ErrorNotification = React.memo((props) => {
    return <>
        {props.errorMessage && <> 
        <div className="error-notification">      
          <div className="sas-container error-message">
            <div>{props.errorMessage}</div>
            <button type="button" className="btn-close" onClick={() => props.onClose()}>
              <div class="sas-icon">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.177 3l2.121 2.121L11.77 9.65l4.528 4.528-2.121 2.121-4.528-4.528-4.528 4.528L3 14.177l4.527-4.528L3 5.121 5.121 3 9.65 7.527z" fill-rule="evenodd"></path>
                </svg>
              </div>
            </button>
          </div>
        </div>
        </>
      }
    </>
});
export default ErrorNotification;
